import axios from 'axios';

export default async (commit, getters) => {
    let data;
    if (!getters.purchaseInfo.bundleId) {
        return;
    }
    if (getters.purchaseInfo.bundleId.length > 6) {
        await commit('updateBundleDetails', {
            'legacyBundleId': true
        });
        return;
    }

    try {
        ({data} = await axios.get(`/api/v1/lookup/slp/package/${getters.purchaseInfo.bundleId}`));
        await commit('updateBundleDetails', {
            ...data
        });
    } catch (error) {
        let errorMessage = 'There was an error fetching the bundle.';

        if (getters.isPartnerLink) {
            errorMessage += ' Please contact your partner for assistance.';
        } else if (getters.isPurchaseLink) {
            errorMessage += ' Please contact your sales rep for assistance.';
        } else {
            errorMessage += ' Please contact support for assistance.';
        }

        if (window.axios.isAxiosError(error)) {
            if (!!error.response) {
                const errorObj = error.response.data;
                window.Sentry.logError(error, {server_event_id: error.response.data.eventId});
                commit('setLinkError', {
                    active: true,
                    code: errorObj.error,
                });
                return;
            } else {
                window.Sentry.logError(error);
                commit('setLinkError', {
                    active: true,
                    code: window.constants.errorCodes.generalError,
                });
            }
        } else if (!getters.hasActiveError) {
            window.Sentry.logError(error);
            commit('setLinkError', {
                active: true,
                code: window.constants.errorCodes.generalError
            });
        }
        return;
    }
}
